import React from 'react';
import ChartistGraph from 'react-chartist';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  Select, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  InputAdornment, FormLabel
} from '@material-ui/core/';
import Typography from '@material-ui/core/Typography';
import { ArrowUpward, ArrowDownward, AccessTime, Remove, Lens, Visibility, } from '@material-ui/icons';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import Button from '../../../components/CustomButtons/Button';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooter';
import CustomInput from '../../../components/CustomInput/CustomInput';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import ImageDropZone from '../../../components/ImageDropZone';

import {
  stackedBarChart,
  multiBarChart,
  emailsSubscriptionChart,
} from '../../../variables/charts';

import dashboardStyle from '../../../assets/jss/material-dashboard-react/views/dashboardStyle';

function PlantOperationDashboard() {
  const [issueStatus, setStatus] = React.useState('monitoring');

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setStatus(event.target.value as string);
  };

  const FormDialog = (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="create-work-order">New Work Order</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={6}>
              <CustomInput
                id="asset-id"
                labelText="Asset ID"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-type"
                labelText="Asset Type"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-location"
                labelText="Asset Location"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-model"
                labelText="Asset Model"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                id="work-description"
                multiline
                rowsMax={4}
                labelText="Work description"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Priority </FormLabel>
              <ToggleButtonGroup
                size="small"
                exclusive
                aria-label="text alignment"
              >
                <ToggleButton value="None" aria-label="none">
                  None
                </ToggleButton>
                <ToggleButton value="low" aria-label="low">
                  Low
                </ToggleButton>
                <ToggleButton value="medium" aria-label="medium">
                  Medium
                </ToggleButton>
                <ToggleButton value="high" aria-label="high">
                  High
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-to"
                labelText="Assigned To"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-team"
                labelText="Assigned Team"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <ImageDropZone />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="addtional"
                labelText="Add Additional"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Create
        </Button>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ backgroundColor: "#fff", padding: "8px 24px" }}>
            <Grid container>
              <Grid container item xs={8} alignContent="center">
                <Select
                  value={issueStatus}
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value="none">None</MenuItem>
                  <MenuItem value="monitoring">Monitoring</MenuItem>
                  <MenuItem value="done">Done</MenuItem>
                </Select>
                <span style={{ marginLeft: "24px" }}>HVAC - ASSET ID - 98977829 / MODEL - PDD2904</span>
              </Grid>
              <Grid container item xs={4} justify="flex-end">
                <Button color="secondary" onClick={handleOpen}>Create new work order</Button>
              </Grid>
            </Grid>
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader>
                  <div style={{ position: "absolute", right: "8px", top: "10px" }} >
                    <Visibility style={{ color: "gray", marginRight: "5px" }} fontSize="small" />
                    <Lens style={{ color: "green" }} fontSize="small" />
                  </div>
                  <Typography color="primary" variant="subtitle2">HVC</Typography>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={6}>
                      <Typography variant="caption">Model</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">PD02904</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">ASSET ID</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">98977829</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">FAIL</Typography>
                    </GridItem>
                    <GridItem xs={6}>
                      <Typography variant="caption">0.9876</Typography>
                    </GridItem>
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="subtitle2">Remaining Useful Life (RUL)</Typography>
                </CardHeader>
                <CardBody>
                  <Typography variant="h6">12 days</Typography>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="subtitle2">Probability of Failure</Typography>
                </CardHeader>
                <CardBody>
                  <Typography variant="h6">89.5%</Typography>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader>
                  <Typography color="primary" variant="subtitle2">Mean Time between Failure</Typography>
                </CardHeader>
                <CardBody>
                  <Typography variant="h6">146 days</Typography>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader>
              <Typography color="primary" variant="subtitle2">Overall Equipment Effectiveness</Typography>
            </CardHeader>
            <CardBody>
              <Typography variant="h3">72.5%</Typography>
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <Remove style={{ color: "gray" }} />
                  No Change
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader>
              <Typography color="primary" variant="subtitle2">Availability</Typography>
            </CardHeader>
            <CardBody>
              <Typography variant="h3">85%</Typography>
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <ArrowDownward color="error" />
                  Lower Availability
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader>
              <Typography color="primary" variant="subtitle2">Performance</Typography>
            </CardHeader>
            <CardBody>
              <Typography variant="h3">90%</Typography>
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <ArrowUpward style={{ color: "green" }} />
                  Improve Rate of Performance
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader>
              <Typography color="primary" variant="subtitle2">Quality</Typography>
            </CardHeader>
            <CardBody>
              <Typography variant="h3">95%</Typography>
            </CardBody>
            <CardFooter stats={true}>
              <div>
                <Remove style={{ color: "gray" }} />
                  No Change
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card chart={true}>
            <CardHeader color="primary">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
              // responsiveOptions={emailsSubscriptionChart.responsiveOptions}
              // listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <Typography color="primary" variant="subtitle1">OEE Chart</Typography>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card chart={true}>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
              // responsiveOptions={emailsSubscriptionChart.responsiveOptions}
              // listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <Typography color="primary" variant="subtitle1">Availability Chart</Typography>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card chart={true}>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
              // responsiveOptions={emailsSubscriptionChart.responsiveOptions}
              // listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <Typography color="primary" variant="subtitle1">Performance Chart</Typography>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card chart={true}>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
              // responsiveOptions={emailsSubscriptionChart.responsiveOptions}
              // listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <Typography color="primary" variant="subtitle1">Quality Chart</Typography>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader>
              <Typography color="primary" variant="subtitle1">Major Losses Identified</Typography>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="custom-chart"
                data={stackedBarChart.data}
                type="Bar"
                options={stackedBarChart.options}
              />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader>
              <Typography color="primary" variant="subtitle1">OEE Chart</Typography>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                className="custom-chart"
                data={multiBarChart.data}
                type="Bar"
                options={multiBarChart.options}
                responsiveOptions={multiBarChart.responsiveOptions}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      { FormDialog}
    </div >
  );
}

export default withStyles(dashboardStyle)(PlantOperationDashboard);
